import React from "react"

import { PrimaryText } from "@front-shared/elements/primaryText.element"

import type { BulkResponsibilityBucket } from "../../../config/bulkResultsInsights.config"
import type { IBulkResultsResponsibilityStat } from "../../../types/bulkResultsInsights.types"

export const BulkResultsPatientResponsibilityComponent: React.FunctionComponent<
    IBulkResultsPatientResponsibilityComponentProps
> = props => {
    return (
        <div className={props.className}>
            <div className="mb-[16px] flex items-baseline gap-[12px]">
                <PrimaryText typography="h5">
                    Patient responsibility
                </PrimaryText>

                <PrimaryText typography="subtitle" className="opacity-60">
                    Patients with a full coverage picture ·{" "}
                    {props.fullCoverageCount} total
                </PrimaryText>
            </div>

            <div className="grid grid-cols-4 gap-[12px] lg:grid-cols-2 sm:grid-cols-1">
                {props.stats.map(stat => {
                    const isSelected = props.selectedBucket === stat.key

                    return (
                        <button
                            key={stat.key}
                            type="button"
                            className={`
                                rounded-[16px] border border-solid p-[20px] text-left shadow-sm
                                ${
                                    isSelected
                                        ? "border-brand-primary bg-brand-primary"
                                        : "border-transparent bg-brand-white"
                                }
                            `}
                            onClick={() => {
                                props.onSelect(stat.key, stat.label)
                            }}
                        >
                            <PrimaryText
                                color={isSelected ? "white" : undefined}
                            >
                                {stat.label}
                            </PrimaryText>

                            <PrimaryText
                                typography="h3"
                                className="mt-[8px]"
                                color={isSelected ? "white" : undefined}
                            >
                                {stat.count}
                            </PrimaryText>

                            {stat.detail ? (
                                <PrimaryText
                                    className="mt-[4px]"
                                    color={isSelected ? "white" : undefined}
                                >
                                    {stat.detail}
                                </PrimaryText>
                            ) : null}

                            {stat.description ? (
                                <PrimaryText
                                    className="mt-[12px]"
                                    color={isSelected ? "white" : undefined}
                                >
                                    {stat.description}
                                </PrimaryText>
                            ) : null}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

interface IBulkResultsPatientResponsibilityComponentProps {
    className?: string
    fullCoverageCount: number
    stats: IBulkResultsResponsibilityStat[]
    selectedBucket?: BulkResponsibilityBucket
    onSelect: (bucket: BulkResponsibilityBucket, label: string) => void
}
